import { Pipe, type PipeTransform } from "@angular/core";

@Pipe({
    name: "appOrderBy",
    standalone: true,
})
export class OrderByPipe implements PipeTransform {
    transform<T>(value: T[], field: string): T[] {
        return value.sort((a: any, b: any) => {
            if (a[field] < b[field]) {
                return -1;
            } else if (a[field] > b[field]) {
                return 1;
            } else {
                return 0;
            }
        });
    }
}
